import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  computed,
  inject
} from '@angular/core';
import { OSKToastService } from '../../services/osk-toast.service';
import { OSKIconComponent } from '../../atoms/osk-icon/osk-icon.component';
import { OSK_UI_LABELS } from '../../core/config/osk-ui-config';

/**
 * Organism: <osk-toast-container>
 * Renders active toast notifications managed by OSKToastService.
 */
@Component({
  selector: 'osk-toast-container',
  standalone: true,
  imports: [OSKIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrl: './osk-toast-container.component.scss',
  template: `
    <div class="osk-toast-container" aria-live="polite" aria-atomic="true">
      @for (toast of toastService.toasts(); track toast.id) {
        <div [class]="'osk-toast osk-toast--' + toast.color" role="status">
          <span class="osk-toast__icon">
            <osk-icon [name]="toast.icon ?? 'info'" [size]="18"></osk-icon>
          </span>
          <div class="osk-toast__body">
            <div class="osk-toast__title">{{ toast.title }}</div>
            @if (toast.description) {
              <div class="osk-toast__description">{{ toast.description }}</div>
            }
          </div>
          <button
            type="button"
            class="osk-toast__close"
            [attr.aria-label]="text().close"
            (click)="toastService.dismiss(toast.id)"
          >
            <osk-icon name="x" [size]="14"></osk-icon>
          </button>
        </div>
      }
    </div>
  `
})
export class OSKToastContainerComponent {
  private readonly labels = inject(OSK_UI_LABELS);
  /** Every string this component renders: an input when given, else the configured label. */
  protected readonly text = computed(() => {
    const labels = this.labels().toast;
    return {
      close: labels.close
    };
  });

  protected readonly toastService = inject(OSKToastService);
}
